import { ATTESTATIONS } from './sendOrchestration.constants';

export const areAttestationsComplete = attestationState =>
  ATTESTATIONS.every(({ type }) => !!attestationState?.[type]);

export const buildAttestationPayload = ({ applicationId, previewResult, attestations }) => ({
  applicationId,
  formBundleId: previewResult?.formBundleId ?? null,
  attestations: ATTESTATIONS.filter(({ type }) => !!attestations?.[type]).map(({ type }) => ({
    type,
  })),
  leGeneration: {
    generatedDate: previewResult?.generatedAt ?? null,
    formDeliveryRequestId: previewResult?.formDeliveryRequestId ?? null,
    documentId: previewResult?.documentId ?? null,
  },
});
